export default function RecommendedEmail({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Recommended by Email")}</legend>
      <input
        className="form-control fontsize-legend"
        name="recommendedEmail"
        onChange={onChange}
        value={searchObject.recommendedEmail || ""}
      />
    </div>
  );
}
